import { Box, CircularProgress } from "@mui/material";
import { useQuery } from "@tanstack/react-query";
import useAuthentication from "../../hooks/useAuthentication";
import { getUserShops } from "../../utility/httpActions/userActions";
import { ProfileLayout } from "./UserPublicProfile";

const UserProfile = () => {
  const { currentUser, isLoggingIn } = useAuthentication();

  const { data: shopsData } = useQuery({
    queryKey: ["userShops", currentUser?.id],
    queryFn: () => getUserShops(currentUser.id),
    enabled: !!currentUser?.id,
  });

  if (isLoggingIn || !currentUser) {
    return (
      <Box sx={{ display: "flex", justifyContent: "center", mt: 8 }}>
        <CircularProgress />
      </Box>
    );
  }

  const shops = shopsData?.shops || [];

  return <ProfileLayout user={currentUser} shops={shops} isOwnProfile />;
};

export default UserProfile;
